/**
 * Validate account data
 * @param {Object} account - Account object
 * @returns {boolean} - True if valid
 */
export const validateAccountData = (account) => {
  return account && typeof account.accountNumber === 'string' && account.accountNumber.length > 0;
};

/**
 * Validate open orders data structure and account match
 * @param {Object} data - Socket data
 * @param {string} accountNumber - Subscribed account number
 * @returns {{valid: boolean, error?: string}} - Validation result
 */
export const validateOpenOrdersData = (data, accountNumber) => {
  // Essential structure check
  if (!data || typeof data !== 'object') {
    return { valid: false, error: 'Invalid data structure' };
  }

  if (!data.message || typeof data.message !== 'object') {
    return { valid: false, error: 'Invalid message structure' };
  }

  // Account number match check (essential for safety)
  if (data.accountNumber && data.accountNumber !== accountNumber) {
    return { valid: false, error: 'Account number mismatch' };
  }

  return { valid: true };
};

/**
 * Sanitize data with safe defaults
 * @param {Object} data - Raw socket data
 * @returns {Object} - Sanitized data
 */
export const sanitizeData = (data) => {
  const orders = Array.isArray(data.message?.orders) ? data.message.orders : [];
  
  // Calculate totals from orders
  // const totalCommission = orders.reduce((sum, order) => {
  //   const commission = parseFloat(order?.commission) || 0;
  //   return sum + commission;
  // }, 0);

  // const totalSpreadCommission = orders.reduce((sum, order) => {
  //   const spreadCommission = parseFloat(order?.spreadCommission) || 0;
  //   return sum + spreadCommission;
  // }, 0);

  return {
    orders,
    balance: data.message?.balance ?? 0,
    equity: data.message?.equity ?? 0,
    freeMarginPercentage: data.message?.freeMarginPercentage ?? 0,
    freeMargin: data.message?.freeMargin ?? 0,
    pnl: data.message?.pnl ?? 0,
    // totalCommission,
    // totalSpreadCommission
  };
};
